factboxAppRouteChanges.$inject = ['$rootScope', '$parse', '$location',
  '$window', 'AnalyticsServ', '$uibModalStack', 'Errors'
];
export default function factboxAppRouteChanges($rootScope, $parse, $location,
  $window, AnalyticsServ, $uibModalStack, Errors) {
  $rootScope.$on('$routeChangeStart', (e, next, prev) => {
    var {
      $$route: route
    } = next;
    if (route) {
      $rootScope.app = route.app ? true : false;
    }

    $rootScope.loading = 'page';

    // persist groupingAttr - save it before change
    // $window.options = $window.options || {};

    // $window.options.group = $rootScope.groupingAttr;
    // $window.options.report = $rootScope.reportType;

    $uibModalStack.dismissAll();

  });
  $rootScope.$on('$routeChangeSuccess', (e, next, prev) => {
    var {
      $$route: route
    } = next;

    $rootScope.loading = false;
    if (!$location.search().finalDestination) {
      // Clear errors on non-redirected successful route changes
      Errors.data = {};
    }

    if (route) {
      AnalyticsServ.page(route.originalPath, $location.search());

      $rootScope.app = route.app ? true : false;

      AnalyticsServ.setChatVisibility(false);
      AnalyticsServ.setFirstSeen();
    }
  });
  $rootScope.$on('$routeChangeError', function (e, current, next, response) {
    // redirects user to login when $routeProvider resolve promises rejected
    var {
      $$route: route
    } = current;

    $rootScope.loading = false;

    // Unauthorized handles 408 403 401
    if (!(response && /408|401|403/.test(response.status))) {
      if (route.originalPath.match(/^\/home/)) {
        $location.url('/home');
        $location.search('finalDestination', true)
        AnalyticsServ.analytics.track(`Redirected to Home`, {
          'Page': route.originalPath
        });
      } else if (route.originalPath.match(/^\/fact/)) {
        $location.url('/fact');
        $location.search('finalDestination', true)
        AnalyticsServ.analytics.track(`Redirected to Fact`, {
          'Page': route.originalPath
        });
      } else {
        $location.path('/signin');
        AnalyticsServ.analytics.track('Redirected to Sign In', {
          'Page': route.originalPath
        });
      }
    }

  });
}



// WEBPACK FOOTER //
// ./project/apps/factbox-app/factbox-app.routechanges.js